import { Component } from '@angular/core';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeConfirmationService } from '../../../Model/EmployeeConfirmation/employee-confirmation.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';

@Component({
  selector: 'app-emp-confirmation-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, DataTablesModule, RouterModule, LoaderComponent],
  templateUrl: './emp-confirmation-detail.component.html',
  styleUrl: './emp-confirmation-detail.component.scss'
})
export class EmpConfirmationDetailComponent {
  isDisabled: boolean = false;
  Datas = [] as any;
  Filter = {
    SelectType: 'i',
    WebESSApprovalRequestTrackingId: 0,
    ESS_EmployeeConfirmationDetailsID: 0,
    EmpMasterId: null,
    ESS_EmployeeConfirmationHistoryDetails: [] as any,
    Remark: null,
  }

  constructor(
    protected common: CommonService,
    private employeeconfirmation: EmployeeConfirmationService,
    private session: SessionService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toast: ToastService
  ) {
    this.route.params.subscribe(params => this.Filter.ESS_EmployeeConfirmationDetailsID = parseInt(params['id']));
    this.common.getPageRights();
    this.Filter.EmpMasterId = this.session.GetUserDetails().UserId;
  }

  ngOnInit(): void {
    this.ESS_EmployeeConfirmationDetailsSelect();
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_EmployeeConfirmationQuestionnare();
    }
    else {
      this.toast.show({ message: 'Please fill all form details', type: toastTypeEnum.warning });
      form.submitted = true;
    }
  }

  ESS_EmployeeConfirmationDetailsSelect() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_EmployeeConfirmationDetailsSelect({ SelectType: "ALL", ESS_EmployeeConfirmationDetailsId: this.Filter.ESS_EmployeeConfirmationDetailsID, EmpMasterId: this.Filter.EmpMasterId, ApprovalStatus: 'ALL' }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.Datas = response.Table1.sort((a: any, b: any) => {
            if (a.QuestionSequence === null || a.QuestionSequence === '' || b.QuestionSequence === null || b.QuestionSequence === '') {
              return -1;
            } else {
              return a.QuestionSequence - b.QuestionSequence;
            }
          });
        }
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmployeeConfirmationQuestionnare() {
    if (this.Datas.filter((e:any) => this.common.ToLowerCase(e.AnswerIsText) == 's' && parseInt(e.Score) > 5).length == 0) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Are you sure to submit?';
      modalRef.result.then((result) => {
        if (result) {
          this.isDisabled = true;
          this.Filter.ESS_EmployeeConfirmationHistoryDetails = [];
          this.Filter.ESS_EmployeeConfirmationHistoryDetails = this.Datas;
          // this.Datas.forEach((element: any) => {
          //   this.Filter.ESS_EmployeeConfirmationHistoryDetails.push({
          //     ESS_QuestionnareTemplateDetailsId: element.ESS_QuestionnareTemplateDetailsId,
          //     Questions: element.Questions,
          //     Answer: this.common.ToLowerCase(element.AnswerIsText)=='t'?element.answer:null,
          //     Score: this.common.ToLowerCase(element.AnswerIsText)=='s'?parseFloat(element.answer):null,
          //     Remarks: null
          //   });
          // });
          this.employeeconfirmation.ESS_EmployeeConfirmationQuestionnare(this.Filter).subscribe({
            next: (response) => {
              if (response.Error_Code == '511') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { this.isDisabled = false; },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    } else {
      this.toast.show({ message: 'Please enter score between 1 to 5', type: toastTypeEnum.warning });
    }
  }

  Cancel() {
    this.router.navigate(['/request/questionnaire/']);
  }
}
